import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './Subscription2.css';
import { useNavigate } from "react-router-dom";

const Subscription2 = () => {
  const location = useLocation();
  const { formData, selectedDate, selectedTime, treatment } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [plans] = useState([
    {
      id: 1,
      name: 'One Time Correction Plan',
      price: '₹699',
      description: [
        'Customized 1 diet plan',
        'Specific health guide',
        '1 phone consultation',
        '1 follow-up',
        'M̶o̶n̶t̶h̶l̶y̶ ̶f̶o̶l̶l̶o̶w̶ ̶u̶p̶s̶',
        '1̶0̶ ̶P̶r̶o̶g̶r̶a̶m̶ ̶f̶e̶a̶t̶u̶r̶e̶d̶ ̶g̶u̶i̶d̶e̶s̶',
        'R̶e̶g̶u̶l̶a̶r̶ ̶f̶o̶l̶l̶o̶w̶ ̶u̶p̶s̶',
        'U̶n̶l̶i̶m̶i̶t̶e̶d̶ ̶w̶h̶a̶t̶s̶a̶p̶p̶ ̶s̶u̶p̶p̶o̶r̶t̶',
      ],
    },
    {
      id: 2,
      name: 'Monthly Nutrition Plan',
      price: '₹6,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Unlimited WhatsApp support',
        'Blood work analysis',
        'Regular follow-ups',
        'N̶o̶ ̶l̶o̶n̶g̶-̶t̶e̶r̶m̶ ̶f̶o̶l̶l̶o̶w̶-̶u̶p̶s̶',
      ],
    },
    {
      id: 3,
      name: '3-Month Plan',
      price: '₹15,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Blood work analysis',
        'Regular follow-ups',
        'Unlimited WhatsApp support',
        'Monthly corrections',
      ],
    },
    {
      id: 4,
      name: 'Six-Month Lifestyle Overhaul',
      price: '₹24,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Blood work analysis',
        'Regular follow-ups',
        'Unlimited WhatsApp support',
        'Monthly corrections',
      ],
    },
  ]);
const navigate = useNavigate();
  const handlePlanSelection = (plan) => {
  navigate(`/booking-form?subscription=2&plan=${plan.id}&treatment=${treatment || ''}`);
    // if (!formData?.name || !formData?.phone || !formData?.email) {
    //   alert('Missing user information. Please fill in all required fields.');
    //   return;
    // }

  //   setLoading(true);
  //   try {
  //     const paymentData = {
  //       transactionId: `TX_${Date.now()}`,
  //       MUID: formData.email.split('@')[0] || 'user',
  //       name: formData.name,
  //       amount: parseInt(plan.price.replace(/[₹,]/g, ''), 10),
  //       number: formData.phone,
  //       email: formData.email,
  //       subscriptionDetails: plan,
  //     };

  //     const response = await axios.post(
  //       'https://54n24jytpd.execute-api.ap-south-1.amazonaws.com/prod/order',
  //       paymentData
  //     );

  //     if (response.data.success && response.data.data?.instrumentResponse?.redirectInfo?.url) {
  //       window.location.href = response.data.data.instrumentResponse.redirectInfo.url;
  //     } else {
  //       throw new Error('Payment URL not received from server');
  //     }
  //   } catch (error) {
  //     console.error('Payment error:', error);
  //     alert('Payment failed: ' + (error.message || 'Unknown error'));
  //   } finally {
  //     setLoading(false);
  //   }
   };

  return (
    <div className="subscription-container">
      <h2>Choose Your Plan</h2>
      <p>{`Booking Date: ${selectedDate} | Time: ${selectedTime}`}</p>

      <div className="subscription-plans">
        {plans.map((plan) => (
          <div className="plan-card" key={plan.id}>
            <h3>{plan.name}</h3>
            <p className="price">{plan.price}</p>
            <ul>
              {plan.description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <button
              className="select-button"
              onClick={() => handlePlanSelection(plan)}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Select Plan'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Subscription2;
